// Routes where the newsletter pop-up must never open: it once covered the 3DS bank modal on the thank-you page.
// Pure, so it is unit-tested. A prefix matches the path itself and anything below it.
const SUPPRESSED_PREFIXES = [
  '/checkout', // payment, confirmation
  '/merch-checkout',
  '/merchandise-success',
  '/wallpaper-success',
  '/buy-gift-card',
];

const EXTRA_COPIES = /^\/order\/[^/]+\/extra-copies(\/|$)/;

export function isPopupSuppressedPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  const p = pathname.split('?')[0];
  if (EXTRA_COPIES.test(p)) return true;
  return SUPPRESSED_PREFIXES.some((x) => p === x || p.startsWith(x + '/'));
}
